import axios from "axios";
import Swal from "sweetalert2";

const instance = axios.create({
//   baseURL: "http://127.0.0.1:8000/api",
  baseURL: process.env.VUE_APP_API_BASE_URL || "https://fbback.developnetwork.net/api",
});

// Request interceptor for adding the bearer token
instance.interceptors.request.use(
  (config) => {
    const stored = localStorage.getItem("user_free");
    if (stored) {
      const user = JSON.parse(stored);
      if (user.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    }
    config.headers.Accept = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      new Swal({
        toast: true,
        position: "top-right",
        iconColor: "white",
        width: 300,
        text: "Unauthorized Action",
        customClass: {
          popup: "bg-danger",
          htmlContainer: 'text-white',
        },
        showConfirmButton: false,
        showCloseButton: true,
        timer: 3000,
        timerProgressBar: true,
      });
    }

    if (error.response && error.response.status === 401) {
      localStorage.removeItem("user_free");
      localStorage.removeItem("user_data");

      if (!window.location.pathname.startsWith("/login")) {
        new Swal({
          toast: true,
          position: "top-right",
          iconColor: "white",
          width: 300,
          text: "Session expired. Please log in again.",
          customClass: {
            popup: "bg-danger",
            htmlContainer: 'text-white',
          },
          showConfirmButton: false,
          showCloseButton: true,
          timer: 3000,
          timerProgressBar: true,
        });

        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default instance;


